export default __webpack_public_path__ + "static/media/cppIcon.bc0941f9.svg";